var render = function render(_c,_vm){return _c('div',_vm._b({class:_vm.$style.group_container},'div',_vm.data,false),[_c('div',{class:_vm.$style.group_header},[_vm._v("\n        "+_vm._s(_vm.props.title)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }